import { SearchAutocomplete } from './SearchAutocomplete';

const searchFormElement = document.getElementById('search-form');
const searchInputElement = document.getElementById('search-input');
const searchClearElement = document.getElementById('clear-input');

// search bar mobile ui code
$('#searchButtonToggle').click(function () {
    $('#searchToggler').fadeIn('fast', function () {
        $('#search-input').focus();
    });
    $('#navbarControls').hide();
    $('#navbarControlsExit').show();
    $('#searchToggler').css('height', 1000);
});
$('#navButtonToggle').click(function () {
    $('.navbar-element').fadeIn('fast');
    $('.secondary-nav-vumedi').fadeIn('fast');
    $('#navbarNavigation').fadeIn('fast');
    $('#navbarControls').hide();
    $('#navbarControlsExit').show();
});
$('#navbarControlsExit').click(function () {
    $('#searchToggler').fadeOut('fast');
    $('.navbar-element').fadeOut('fast');
    $('.secondary-nav-vumedi').fadeOut('fast');
    $('#navbarNavigation').fadeOut('fast');
    $('#navbarControlsExit').hide(); // fast is 200 ms
    $('#navbarControls').delay(200).show(0);
});

document.addEventListener('DOMContentLoaded', () => {
    if (searchFormElement && searchInputElement && searchClearElement) {
        new SearchAutocomplete().initialize(searchFormElement, searchInputElement, searchClearElement);
    }
});
